let popup = {
    init() {
        this.popup();
    },
    popup() {
        $(document).on('click', '.btn-popup', function (event) {
            let id = $(this).attr('id');
            popup.beforeOpen(id, $(this), event);
            $('.popup.' + id).fadeIn(300);
        });

        $(document).click(function (event) {
            if ($(event.target).hasClass('popup')) {
                $(".popup").fadeOut(300);
                popup.handleForm();
            }
        });

        $(document).on('click', '.popup .icon-close, .popup .close', function (event) {
            $(".popup").fadeOut(300);
            popup.handleForm();
        });

    },
    beforeOpen(id, element, event) {
        if (id === 'popup-postuler') {
            let title = element.attr('data-title');
            let nid = element.attr('data-node-id');

            $('.popup-postuler .title').text(title);
            $('.popup-postuler select[name="offre_d_emploi"] option[value="' + nid + '"]').prop('selected', true);
        }
        if (id === 'popup-compil') {
            event.preventDefault();
            let url = element.attr('href');
            let infos = element.attr('data-infos');
            $('.popup-compil .confirm').attr('href', url);
            $('.popup-compil .infos').text(infos);
        }
    },
    handleForm() {
        if ($('form.webform-submission-postuler-offre-d-emploi-form').length) {
            $('form.webform-submission-postuler-offre-d-emploi-form').get(0).reset();
        }
    }
}

export default popup;
